import {
  em,
  strikeThrough,
  strong,
  superscript,
  underline,
} from './portableTextDecorators'
import {
  chatTrigger,
  externalLink,
  internalLink,
  textColor,
} from './portableTextAnnotations'
import {
  PortableCode,
  PortableFeatures,
  PortableImage,
  PortableReadMore,
  PortableRichTable,
  PortableSpecs,
  PortableTable,
  PortableVehicleAlbum,
  PortableVehicleGallery,
} from './portableTextComponents'
import { PortableStylesFull } from './portableTextStyles'

// Rich Text without custom components
export const richTextSimple = [
  {
    type: 'block',
    styles: PortableStylesFull,
    marks: {
      decorators: [strong, em, superscript, underline, strikeThrough],
      annotations: [internalLink, externalLink, textColor],
    },
  },
]

export const strongEmLink = [
  {
    type: 'block',
    styles: PortableStylesFull,
    marks: {
      decorators: [strong, em, superscript, underline, strikeThrough],
      annotations: [internalLink, externalLink, textColor, chatTrigger],
    },
  },
]

export const strongEmLinkWithReadMore = [
  {
    type: 'block',
    styles: PortableStylesFull,
    marks: {
      decorators: [strong, em, superscript, underline, strikeThrough],
      annotations: [internalLink, externalLink, textColor],
    },
  },
  PortableReadMore,
]

export const richTextContent = [
  {
    type: 'block',
    styles: PortableStylesFull,
    marks: {
      decorators: [strong, em, superscript, underline, strikeThrough],
      annotations: [internalLink, externalLink, textColor],
    },
  },

  // Migrated portable text components
  PortableImage,
  PortableTable,
  PortableRichTable,
  PortableCode,
  PortableSpecs,
]

export const articleContent = [
  {
    type: 'block',
    styles: PortableStylesFull,
    marks: {
      decorators: [strong, em, superscript, underline, strikeThrough],
      annotations: [internalLink, externalLink, textColor],
    },
  },

  // Migrated portable text components
  PortableImage,
  PortableTable,
  PortableRichTable,
  PortableCode,
  PortableFeatures,
  PortableSpecs,
  PortableVehicleAlbum,
  PortableVehicleGallery,
]
